

// eslint-disable-next-line
import React, { useState, useEffect } from "react";
import { RiCloseLargeFill } from "react-icons/ri";
import { MdOutlineAddToDrive } from "react-icons/md";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { toast, ToastContainer } from "react-toastify";
// eslint-disable-next-line
import "react-toastify/dist/ReactToastify.css";
import uploadImage from "../../helpers/uploadImage";
import axios from "axios";
import summaryApi from "../../common/Api";
import Cookies from "js-cookie";
import productCategory from "../../helpers/productCategory";
import DisplayImageProduct from "../displayImageProduct.js/displayImageProduct";

const UploadProduct = ({ onClose, fetchProducts }) => {
  // State Management
  const [clicked, setClicked] = useState(false);
  const tokenApi = Cookies.get("tokenApi");
  const [formData, setFormData] = useState({
    name: "",
    brand: "",
    category: "",
    product_image: [],
    price: "",
    discount: "",
    quantity: "",
    description: "",
  });

  const [selectedImage, setSelectedImage] = useState(null);
  const [openImage, setOpenImage] = useState(false);

  // Helper Functions
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCategoryChange = (e) => {
    setFormData((prev) => ({ ...prev, category: e.target.value }));
  };

  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);
    const validImageTypes = ["image/jpeg", "image/png", "image/webp"];

    try {
      const uploadedImages = await Promise.all(
        files.map((file) => {
          if (validImageTypes.includes(file.type)) {
            return uploadImage(file);
          } else {
            throw new Error("Invalid file type.");
          }
        })
      );
      setFormData((prev) => ({
        ...prev,
        product_image: [...prev.product_image, ...uploadedImages],
      }));
      toast.success("Images uploaded successfully", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    } catch (error) {
      toast.error(error.message, {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    }
  };

  const handleRemoveImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      product_image: prev.product_image.filter((_, i) => i !== index),
    }));
    toast.info("Image removed", {
      position: "bottom-center",
      className: "custom-toast",
      autoClose: 2000,
      draggable: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggablePercent: 60,
    });
  };

  const validateForm = () => {
    const fields = Object.values(formData);
    if (fields.some((field) => field === "" || field.length === 0)) {
      toast.info("All fields are required", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      return false;
    }
    return true;
  };

  const addProduct = async () => {
    const token = Cookies.get("tokenApi");
    if (!token) {
      toast.error("Authentication token missing.", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      return;
    }

    const formDataObj = new FormData();
    Object.keys(formData).forEach((key) => {
      if (Array.isArray(formData[key])) {
        formData[key].forEach((item) => formDataObj.append(key, item));
      } else {
        formDataObj.append(key, formData[key]);
      }
    });

    try {
      const response = await axios.post(
        summaryApi.addProduct.url,
        formDataObj,
        {
          headers: {
            Authorization: `Bearer ${tokenApi}`,
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
          withCredentials: true,
        }
      );
      toast.success("Product added successfully", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
      return response.data;
    } catch (error) {
      const errorMessage =
        error.response?.status === 401
          ? "Unauthorized. Check your credentials."
          : "Error adding product";
      toast.error(errorMessage, {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (clicked || !validateForm()) return;
    setClicked(true);

    try {
      await addProduct();
      await fetchProducts();
      onClose();
    } catch {
      toast.error("Error submitting product.", {
        position: "bottom-center",
        className: "custom-toast",
        autoClose: 2000,
        draggable: true,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggablePercent: 60,
      });
    }
  };

  // Effect to notify about required fields on component load
  useEffect(() => {
    toast.info("You must fill in all fields", {
      position: "bottom-center",
      className: "custom-toast",
      autoClose: 2000,
      draggable: true,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggablePercent: 60,
    });
  }, [fetchProducts]);

  return (
    <div className="relative p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="font-semibold text-xl">Upload Product</h2>
        <RiCloseLargeFill
          className="hover:text-red-600 cursor-pointer"
          onClick={onClose}
        />
      </div>

      <form className="space-y-4" onSubmit={handleSubmit}>
        {/** Input Fields */}
        {["name", "brand", "price", "discount", "quantity", "description"].map(
          (field) => (
            <div key={field}>
              <label
                htmlFor={field}
                className="block text-md font-medium text-gray-700 mb-2 capitalize"
              >
                {field.replace("_", " ")}:
              </label>
              {field === "description" ? (
                <textarea
                  id={field}
                  name={field}
                  rows="4"
                  value={formData[field]}
                  onChange={handleInputChange}
                  className="resize-none p-2 border bg-slate-100 rounded-md w-full"
                  placeholder={`Enter the ${field}`}
                />
              ) : (
                <input
                  type={
                    field === "price" || field === "quantity"
                      ? "number"
                      : "text"
                  }
                  id={field}
                  name={field}
                  value={formData[field]}
                  onChange={handleInputChange}
                  className="p-2 border bg-slate-100 rounded-md w-full"
                  placeholder={`Enter the ${field}`}
                />
              )}
            </div>
          )
        )}

        <div>
          <label
            htmlFor="category"
            className="block text-md font-medium text-gray-700 mb-2"
          >
            Category:
          </label>
          <select
            id="category"
            name="category"
            value={formData.category}
            onChange={handleCategoryChange}
            className="p-2 border bg-slate-100 rounded-md w-full"
          >
            <option value="">Select Category</option>
            {productCategory.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>

        {/** Image Upload Section */}
        <div>
          <label className="block text-md font-medium text-gray-700 mb-2">
            Product Images:
          </label>
          <label className="flex flex-col items-center gap-4 text-gray-500 bg-slate-100 p-5 cursor-pointer rounded-md">
            <input
              type="file"
              id="product_image"
              name="product_image"
              multiple
              accept="image/*"
              onChange={handleImageChange}
              hidden
            />
            <MdOutlineAddToDrive className="text-3xl" />
            <span>Upload Product Images</span>
          </label>

          <div className="flex gap-4 flex-wrap mt-4">
            {formData.product_image.map((image, index) => (
              <div key={index} className="relative group">
                <img
                  src={image}
                  alt="product"
                  className="w-24 h-24 object-cover rounded-md"
                  onClick={() => {
                    setSelectedImage(image);
                    setOpenImage(true);
                  }}
                />
                <AiOutlineCloseCircle
                  className="absolute top-1 right-1 text-red-600 cursor-pointer"
                  onClick={() => handleRemoveImage(index)}
                />
              </div>
            ))}
          </div>
        </div>

        <button
          disabled={clicked}
          className="bg-main-background py-2 px-4 mt-4 rounded-md text-white"
        >
          Upload Product
        </button>
      </form>

      {openImage && (
        <DisplayImageProduct
          image={selectedImage}
          onClose={() => setOpenImage(false)}
        />
      )}

      <ToastContainer />
    </div>
  );
};

export default UploadProduct;
